module.exports = __webpack_public_path__ + "img/Git.ee1369e9.png";